




































import { namespace } from 'vuex-class'
import { Vue, Component, Watch } from 'vue-property-decorator'
import ProcedureForm from '@/UI/Auction/Procedure/ProcedureForm.vue'
import BatchDetail from '@/UI/Batch/BatchDetail.vue'
import { ProcedureDto } from '@/Application/Procedures'
import { BatchDto } from '@/Application/Batch'

const auctionStore = namespace('auction')
const procedureStore = namespace('procedure')
@Component({
  components: {
    ProcedureForm,
    BatchDetail
  }
})

export default class ProcedureLayout extends Vue {
  isValid = false

  @auctionStore.Getter
  public resforCode!: string

  @auctionStore.Getter
  public procedureData!: string[]

  @auctionStore.Action
  public setProcedureData!: (ProcedureData: string[]) => void

  @procedureStore.Getter
  public currentProcedure!: ProcedureDto | undefined

  @procedureStore.Getter
  public resultasBatches!: BatchDto[]

  @procedureStore.Getter
  public riscoBatches!: BatchDto[]

  get selectedRiscoBatches (): string[] {
    return this.filterSelectedBatches(this.riscoBatches)
  }

  get selectedResultasBatches (): string[] {
    return this.filterSelectedBatches(this.resultasBatches)
  }

  get selectedBatchesString (): string {
    return this.procedureData.join(', ')
  }

  public filterSelectedBatches (batches: BatchDto[]): string[] {
    const selectedBatches: string[] = []
    for (const batch of batches) {
      const isSelected = this.procedureData.indexOf(batch.batchId) !== -1
      if (isSelected) {
        selectedBatches.push(batch.batchId)
      }
    }
    return selectedBatches
  }

  @Watch('isValid')
  onIsValidUpdated (newValue: boolean): void {
    this.$emit('formValid', newValue)
  }

  public onResultasBatchSelected ($event: string[]): void {
    this.addBatchIdToSelected($event, this.selectedRiscoBatches)
  }

  public onRiscoBatchSelected ($event: string[]): void {
    this.addBatchIdToSelected($event, this.selectedResultasBatches)
  }

  public addBatchIdToSelected (newValues: string[], oldValues: string[]): void {
    const updatedBatches = [
      ...oldValues,
      ...newValues
    ]
    const alreadyFound: string[] = []
    updatedBatches.map(current => {
      if (alreadyFound.indexOf(current) === -1) {
        alreadyFound.push(current)
      }
    })
    this.setProcedureData(alreadyFound)
    this.isValid = alreadyFound.length > 0
  }
}
